module.exports = __webpack_public_path__ + "fonts/montserrat-v30-latin-700.f26608f.woff2";